import { T_HEADER_PAGE_CONSTANTS } from './TYPES'

const EN_HEADER_PAGE_CONSTANTS: T_HEADER_PAGE_CONSTANTS = {
  PROFILE_TEXT: 'Profile',
  LOGOUT_TEXT: 'Logout'
}

export default EN_HEADER_PAGE_CONSTANTS
